<template>
  <div>
    <div
      v-if="loading === true"
      class="spinner-grow text-primary"
      style="margin-top: 15%;margin-left: 45%;"
    />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2 mr-1"
          @click="confirmDeleteText(deletedArry)"
        >
          UnAssign Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2"
          data-toggle="modal"
          data-target="#createRepresentativeModal"
        >
          New Assign
        </button>
        <create
          v-if="$router.currentRoute.name === 'representatives'"
          @refresh="renderTable()"
        />
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :actions-obj="actionsArray"
      @choosenObject="getEditedObject($event)"
      @dynamicAction="handleActions($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
      :representative="editedRepresentative"
      @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import representativeService from '@/services/representativeService'
import clientService from '@/services/clientService'

export default {
  components: {
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      forRefresh: '',
      actionsArray: [],
      editedRepresentative: '',
      columns: [

        {
          label: 'Full Name',
          field: 'full_name',
        },
        {
          label: 'Phone',
          field: 'phone_number',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'E-Id',
          field: 'eid_number',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  watch: {
    forRefresh(val) {
      this.getRepresentatives(this.$route.params.id)
    },
  },
  created() {
    this.getRepresentatives(this.$route.params.id)
    console.log('vvvvv', this.$router.currentRoute.name)
  },
  methods: {
    getRepresentatives(id) {
      this.loading = true
      representativeService.index(id).then(response => {
        this.rows = response.data.data
        this.loading = false
        console.log('%%%%%%%%%%%%%%', this.rows)
        console.log(this.rows)
        console.log(this.columns)
      })
    },
    // handleActions(id) {
    //   alert(id)
    //   this.$router.push({ name: 'representatives', params: { id: 1 } })
    // },
    getEditedObject(obj) {
      this.editedRepresentative = obj
      console.log('======>', this.editedRepresentative)
    },
    catchVar(e) {
      this.forRefresh = e
    },
    catchIds(ids) {
      console.log('ppppp', ids)
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      console.log('arr', arr.length)
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            clientService.unAssign(this.$route.params.id, arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been un-assigned.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => Promise.reject(error))
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    renderTable() {
      this.getRepresentatives(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
